import { useState, useRef, useEffect } from "react";
import { useContext } from "react";
import { anantaContext } from "./Home";

import videoAnanta from "../../Assets/AsetAnanta/videoAnanta.mp4";

import kupu1 from "../../Assets/AsetAnanta/1.png";
import kupu2 from "../../Assets/AsetAnanta/2.png";
import kupu3 from "../../Assets/AsetAnanta/3.png";
import kupu4 from "../../Assets/AsetAnanta/4.png";

import logoAnanta from "../../Assets/AsetAnanta/logoAnanta.png";

const VideoAnanta = (props) => {
  const [isPlaying, setIsPlaying] = useState(false);

  const videoRef = useRef(null);
  const { click, end, setEnd } = useContext(anantaContext);

  const togglePlay = () => {
    if (!isPlaying) {
      setIsPlaying(!isPlaying);
      videoRef.current.play();
    }
  };

  useEffect(() => {
    videoRef.current.addEventListener("ended", (e) => {
      setEnd(1);
    });
  });

  const skipVideo = () => {
    const duration = videoRef.current.duration;
    videoRef.current.pause();
    videoRef.current.currentTime = duration;
    setEnd(1);
  };

  function detectIos() {
    var isiOS = !!navigator.userAgent.match(/(iPod|iPhone|iPad)/i);
    console.log(props.height);
    if (isiOS) {
      return (
        <div style={{ opacity: click == 3 && "0" }} id="VideoAnanta">
          {isPlaying && !end && (
            <div className="skip" onClick={() => skipVideo()}>
              Skip video
            </div>
          )}

          <div className="copyRight">
            <img className="umnDoc" src="/favicon.ico" />
            <span>© Prabangkara, Syandana, dan Wiskira OMB UMN 2023</span>
          </div>

          <div
            style={{
              zIndex: end === 1 && "0",
              width: click === 2 ? "200vw" : "100vw",
            }}
            className="box-video-ananta">
            <div
              style={{
                opacity: isPlaying && "0",
                transition: "1s",
                backgroundColor: "rgba(215, 116, 41, 1)",
                backgroundImage: "url(/Assets/AsetAnanta/backgroundIos.jpg)",
              }}
              className="boxMulai">
              <img
                className="kupu2Kanan"
                alt="kupu2Kanan kupu2"
                src={kupu3}
              />
              <img
                className="kupu2Kiri"
                alt="kupu2Kiri"
                src={kupu2}
              />

              <div className="box-text">
                <img
                  className="bintangKiri"
                  alt="bintangKiri"
                  src={kupu1}
                />

                <span>
                  <img
                    className="Ananta"
                    src={logoAnanta}
                  />
                  Kepingan Kisah <br />
                  yang Terlukis Abadi
                  <img
                    className="bintangKanan"
                    alt="bintangKanan"
                    src={kupu1}
                  />
                </span>
                <div onClick={() => togglePlay()} className="buttonMulai">
                  <div>Memulai Ananta</div>
                </div>
              </div>
            </div>
            {/* <img
            style={{ opacity: isPlaying && "0", transition: "1s" }}
            src="/Assets/FotoDivisi/LogoAnanta.svg"
            alt="logo ananta"
            className="logo-ananta"
          /> */}
            <video
              style={{
                width: click === 2 ? "300vw" : "100vw",
                transition: "1s",
              }}
              ref={videoRef}
              className="video-ananta"
              playsInline>
              <source
                className="video-ananta"
                src={videoAnanta}
                type="video/mp4"
              />
            </video>
          </div>
        </div>
      );
    } else {
      return (
        <div style={{ opacity: click == 3 && "0" }} id="VideoAnanta">
          {isPlaying && !end && (
            <div className="skip" onClick={() => skipVideo()}>
              Skip video
            </div>
          )}
          <div className="copyRight">
            <img className="umnDoc" src="/favicon.ico" />
            <span>© Prabangkara, Syandana, dan Wiskira OMB UMN 2023</span>
          </div>
          <div
            style={{
              zIndex: end === 1 && "0",
              width: click === 2 ? "200vw" : "100vw",
            }}
            className="box-video-ananta">
            <div
              style={{ opacity: isPlaying && "0", transition: "1s" }}
              className="boxMulai">
              <img
                className="kupu2Kanan"
                alt="kupu2Kanan kupu2"
                src={kupu3}
              />
              <img
                className="kupu2Kiri"
                alt="kupu2Kiri"
                src={kupu2}
              />

              <div className="box-text">
                <img
                  className="bintangKiri"
                  alt="bintangKiri"
                  src={kupu1}
                />

                <span>
                  <img
                    className="Ananta"
                    src={logoAnanta}
                  />
                  Kepingan Kisah <br />
                  yang Terlukis Abadi
                  <img
                    className="bintangKanan"
                    alt="bintangKanan"
                    src={kupu1}
                  />
                </span>
                <div onClick={() => togglePlay()} className="buttonMulai">
                  <div>Memulai Ananta</div>
                </div>
              </div>
            </div>
            {/* <img
            style={{ opacity: isPlaying && "0", transition: "1s" }}
            src="/Assets/FotoDivisi/LogoAnanta.svg"
            alt="logo ananta"
            className="logo-ananta"
          /> */}
            <video
              style={{
                width: click === 2 ? "300vw" : "100vw",
                transition: "1s",
              }}
              ref={videoRef}
              className="video-ananta"
              playsInline>
              <source
                className="video-ananta"
                src={videoAnanta}
                type="video/mp4"
              />
            </video>
          </div>
        </div>
      );
    }
  }

  return <>{detectIos()}</>;
};

export default VideoAnanta;
